module.exports = __webpack_public_path__ + "static/media/teamX_Logo-01.08e39da2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Mainpage/Contact/teamX_Logo-01.png
// module id = 314
// module chunks = 0